<template>
  <ConfirmationModal
    :key="componentKey"
    :entity="apiTokenToDelete.apiToken"
    :title="$t('DELETE_MODAL_TITLE')"
    :confirm-action-text="$t('DELETE')"
    :confirm-button-loading="isLoading"
    @confirm="onConfirmModal()"
    @close="onCloseDeleteModal()"
    @dismiss="onCloseDeleteModal()"
  >
    <div v-if="!apiTokenToDelete.references.hasReference">
      <div>
        <div
          bs-loading-overlay
          class="loader-container size-sm"
        />
        <span v-t="'NONE_USAGE_TEXT.THE_API_ACCESS_TOKEN'" /><strong>{{ apiTokenName }}</strong><span v-t="'NONE_USAGE_TEXT.HAS_NOT_BEEN_USED'" />
      </div>
    </div>

    <div v-if="apiTokenToDelete.references.hasReference">
      <span v-t="'WITH_USAGE_TEXT.ARE_YOU_SURE_YOU_WANT_TO_DELETE'" /><strong>{{ apiTokenName }}</strong><span v-t="'WITH_USAGE_TEXT.HAS_BEEN_LAST_USED_ON'" />
      <div class="well well-sm m-t-10 m-b-0">
        <div class="form-horizontal references-list">
          <div class="row">
            <div>
              <ul class="list-unstyled form-control-static list-text-overflow">
                <li>
                  <span v-t="'DATE_TIME'" /><strong>{{ apiTokenUsageLoginTime }}</strong>
                </li>
                <li>
                  <span v-t="'RESOURCE'" /><strong>{{ apiTokenUsageResource }}</strong>
                </li>
                <li>
                  <span v-t="'IP'" /><strong>{{ apiTokenUsageIP }}</strong>
                </li>
              </ul>
            </div> 
          </div>
        </div>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>

import messages from '../../../locales';
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import { apiTokensService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'ApiTokenDeleteModal',
  components: { ConfirmationModal },
  props: {
    apiToken: {
      type: Object,
      default() {
        return {};
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },  

  data() {
    return {
      componentKey: 0,
    };
  },

  computed: {
    apiTokenToDelete() {
      var apiToken = this.apiToken;

      var response = {};
      response.apiToken = apiToken; 
      response.references = {
        hasReference: apiTokensService.doesItHaveUsage(apiToken),
        lastUse: apiTokensService.getLastUse(apiToken)
      };
      
      return response; 
    },
    apiTokenName() {
      return this.apiTokenToDelete.apiToken.name;
    },
    apiTokenUsageLoginTime() {
      return this.apiTokenToDelete.references.lastUse.loginTime;
    },
    apiTokenUsageResource() {
      return this.apiTokenToDelete.references.lastUse.protectedResource;
    },    
    apiTokenUsageIP() {
      return this.apiTokenToDelete.references.lastUse.ipAddress;
    }
  },

  methods: {
    onConfirmModal(){
      this.$emit('confirm-token-modal');
    },
    onCloseDeleteModal() {
      this.$emit('close-delete-token-modal');
      this.componentKey++;
    }
  },
  
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style>

</style>